<template>
  <div class="w-full space-y-4">
    <!-- Add New Factor Button -->
    <div 
      class="bg-white rounded-lg border border-gray-300 p-6 !mb-8 cursor-pointer hover:shadow-md transition-all duration-200 active:scale-95"
      @click="goToDetail(null)"
    >
      <div class="flex items-center justify-between group">
        <div class="flex items-center gap-3">
          <img src="/img/svg/add-circle.svg" alt="Add" class="w-6 h-6" />
          <span class="text-gray-900 font-medium"> فاکتور جدید</span>
        </div>
        <svg class="w-5 h-5 text-gray-400 group-hover:text-gray-600 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
        </svg>
      </div>
    </div>

    <!-- Request Items List -->
    <div v-if="request_items.length > 0" class="space-y-3">
      <div 
        v-for="item in request_items"
        :key="item.Id"
        :class="'bg-white rounded-xl border py-3 px-4 cursor-pointer transition-all duration-200 hover:shadow-lg hover:-translate-y-0.5 ' + (item.selected ? 'border-blue-500 bg-blue-50 ring-2 ring-blue-200' : 'border-gray-200 hover:border-blue-300')"
        v-longclick="() => long_click(item)"
        @click="goToDetail(item)"
      >
        <div class="flex items-start gap-2">
          <!-- Icon/Status Indicator -->
       
          <!-- Main Content -->
          <div class="flex-1 min-w-0">
            <div class="mb-2">
              <h3 class="text-sm font-bold text-gray-900 truncate">{{ item.RequestName }}</h3>
              <p v-if="item.PFactorTitle" class="text-sm text-gray-600 mt-1">{{ item.PFactorTitle }}</p>
            </div>
            
            <div class="flex items-center gap-4  pt-2 border-t border-gray-100">
              <!-- Date -->
              <div class="flex items-center gap-2 text-xs text-gray-500">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                <span class="font-medium">{{ item.CreatedAt }}</span>
              </div>
              
              <!-- Status Badge -->
              <div v-if="item.DocStatusId != undefined" class="flex items-center justify-end gap-2">
                <span :class="item.DocStatusId == 0 ? 'bg-yellow-100 text-yellow-800' : 'bg-green-100 text-green-800'" 
                      class="px-2 py-1 rounded-full text-xs font-medium">
                  {{ item.DocStatusId == 0 ? 'در حال ویرایش' : 'نهایی شده' }}
                </span>
              </div>
            </div>
          </div>
          
          <!-- Arrow Icon -->
          <div class="flex-shrink-0 self-center">
            <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
            </svg>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div v-else class="bg-white rounded-xl border border-dashed border-gray-300 p-12 text-center">
      <div class="max-w-2xl mx-auto">
        <div class="w-20 h-20 mx-auto mb-4 rounded-full bg-gray-100 flex items-center justify-center">
          <svg class="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        </div>
        <p class="text-gray-500 font-medium mb-2">فاکتوری وجود ندارد</p>
        <p class="text-sm text-gray-400">برای شروع، روی دکمه زیر کلیک کنید</p>
      </div>
    </div>


  </div>
</template>

<script>
  import InfiniteLoading from 'vue-infinite-loading'
  import Treeselect, { ASYNC_SEARCH } from '@riophae/vue-treeselect'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  import { bus } from '../../../main'
  import { longClickDirective } from 'vue-long-click'
  import Vue from 'vue'
  import mapboxgl from "mapbox-gl";
  import VueSignaturePad from 'vue-signature-pad'
  
  Vue.use(VueSignaturePad)
  
  const longClickInstance = longClickDirective({ delay: 500, interval: 5000 })
  Vue.directive('longclick', longClickInstance)
  
  const simulateAsyncOperation = fn => {
    setTimeout(fn, 200)
  }

  export default {
    props: [
      'passing_data'
    ],

    data() {
      return {
        doc_type: 112,
        dialog_model: false,
        status_summary: '',
        active_tab: 0,
        selected_status_for_change: 0,
        product_info_dialog: false,
        selected_product_info: {},
        list: [],
        status_list: [],
        errors: [],
        post_items: [],
        selected_post: 0,
        dialog_factor: false,
        enable_finalize: false,
        selected_branch: 0,
        request_items: [],
        last_request_items: [],
        request_statuses: [],
        show_loading: false,
        page: 0,
        request_summary: '',
        selected_request: null,
        selected_user: null,
        disable_click: false,
        category_items: [],
        selected_category: 0,
        normalizer_requests(node) {
          return {
            id: node.Id,
            label: node.Title,
          }
        },
        normalizer_persons(node) {
          return {
            id: node.Id,
            label: node.UserName,
          }
        },
        first: true,
      }
    },
    components: {
      InfiniteLoading,
      Treeselect
    },
    watch: {
      selected_category: function (val) {
        this.selected_request = null
        this.selected_user = null
      }
    },
    mounted() {
      this.get_informher_master();
    },

    methods: {
      get_tab_style(index) {
        if (index == this.active_tab) {
          return 'blue'
        } else {
          return 'white'
        }
      },
      set_active_tab(index) {
        this.active_tab = index;
      },
      infiniteHandler($state) {
        var self = this
        if (this.first) {
          setTimeout(() => {
            $state.loaded()
          }, 1000)
          return false
        }

        console.log('hiii' + self.last_request_items.length)
        setTimeout(() => {
          self.page += 1
          self.get_pre_requests($state)
        }, 1000)
      },
      open_image(img) {
        window.open(img, '_blank')
      },
      goToDetail(item) {
        if (this.disable_click) {
          return
        }
        var editable = 0;
        var master_id = 0;
        if (item == null) {
          editable = 1;
          master_id = 0;
        } else {
          master_id = item.MasterFactorId
          if (item.DocStatusId == 0) {
            editable = 1;
          } else {
            editable = 0;
          }
        }
        this.$router.push({ path: '/report-request/informher-items/' + this.$route.params.req_id + '/' + master_id + "/" + this.doc_type + "/" + editable })
      },
      long_click(item) {
        var self = this;
        if (item.selected == null) {
          item.selected = true
          console.log("long click worked")
        } else {
          item.selected = null
        }
        this.disable_click = true
        setTimeout(function () {
          self.disable_click = false
        }, 1000)

        if (this.request_items.filter(x => x.selected == true).length > 0) {
          this.enable_finalize = true;
        } else {
          this.enable_finalize = false;
        }
        this.$forceUpdate()
      },
      card_style(item) {
        if (item.selected) {
          return "blue";
        } else {
          return "";
        }
      },
      get_informher_master() {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          ExpertId: user_id,
          RequestId: this.$route.params.req_id,
        }
        this.axios.post('/GetMasterInformHer', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              self.request_items = response.data.items.filter(x => x.DocType == self.doc_type);
            }
          }).catch(e => {
            this.errors.push(e)
          })
      },

      undo() {
        this.$refs.signaturePad.clearSignature()
      },
      save() {
        const { isEmpty, data } = this.$refs.signaturePad.saveSignature('image/png')
        var file = this.dataURLtoFile(data, 'signature.png')
        console.log(file)
        this.upload_image(file)
      },
      upload_image(image_data) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        var form_data = new FormData()
        form_data.append('UserId', user_id)
        form_data.append('ProcessId', this.$route.rec_id)
        form_data.append('Format', 'png')
        form_data.append('ReqType', this.req_type)
        form_data.append('Picture', image_data)

        this.axios.post('UploadFile', form_data, {})
          .then(response => {
            self.send_signature(response.data.ArchiveId, response.data.ImageName)
          }).catch(e => {
            this.errors.push(e)
          })
      },
      dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(',')
        var mime = arr[0].match(/:(.*?);/)[1]
        var bstr = atob(arr[1])
        var n = bstr.length
        var u8arr = new Uint8Array(n)

        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }

        return new File([u8arr], filename, { type: mime })
      },

      send_signature(archive_id, file_name) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()

        var sign_type = 0

        if (this.req_type == 4) {
          sign_type = 1
        }
        if (this.req_type == 5) {
          sign_type = 2
        }

        const send_data = {
          UserId: user_id,
          ProcessId: this.$route.params.rec_id,
          ImageName: file_name,
          ArchiveId: archive_id,
          SigType: sign_type,
        }
        this.axios.post('/SetRequestSignature', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              if (self.req_type == 4 || self.req_type == 5) {
                self.$router.push({ name: 'requestAddress', params: { rec_id: self.$route.params.rec_id } })
              }
            } else {
              bus.$emit('show_toast', [1500, self.$t('errorUploadSign')])
            }
          }).catch(e => {
            this.errors.push(e)
          })
      },
    }
  }
</script>

<style scoped>
/* Custom styles */
</style>
